import { Route, Routes } from "react-router";
import { APP_ROUTES } from "@/pages/routes";
import SplashPage from "@/pages/SplashPage";
import BlogListingPage from "@/pages/blog/BlogListingPage";
import BlogPostPage from "@/pages/blog/BlogPostPage";
import FAQPage from "@/pages/FAQPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import AboutPage from "@/pages/AboutPage";
import ResourcesPage from "@/pages/ResourcesPage";

function App() {
  return (
    <div className="relative min-h-screen overflow-y-auto">
      <Routes>
        <Route index element={<SplashPage />} />
        <Route path={APP_ROUTES.BLOG} element={<BlogListingPage />} />
        <Route path={APP_ROUTES.BLOG_POST} element={<BlogPostPage />} />
        <Route path={APP_ROUTES.FAQ} element={<FAQPage />} />
        <Route path={APP_ROUTES.PRIVACY} element={<PrivacyPage />} />
        <Route path={APP_ROUTES.TERMS} element={<TermsPage />} />
        <Route path={APP_ROUTES.ABOUT} element={<AboutPage />} />
        <Route path={APP_ROUTES.RESOURCES} element={<ResourcesPage />} />
        <Route path="*" element={<SplashPage />} />
      </Routes>
    </div>
  );
}

export default App;
